import { createBrowserRouter, defer, LoaderFunctionArgs, redirect, useRouteError } from 'react-router-dom';
import { lazy } from 'react';
import NotFound from './pages/NotFound';
import {
    getEventBlockListV2,
    getProfileWithPath,
    getSpaceHome,
    getSpaceHomeBlockData,
    getSpaceHomeData,
    getSpaceHomeDesignDataV2,
    getSpaceHomeSpeedBlockData,
    getSpaceProfileByPath,
    getSpaceProfileByUserId,
} from './services/spacehome.service';
import LazyMall from './pages/LazyMall';
import {
    AdditionalPayResultType,
    ExtraChagreType,
    getAdditionalPayResult,
    getExtraChargeInfo,
    getMallId,
    getMallInfo,
    getMallTagList,
    getMallUserInfo,
    getMilageList,
    getPinedNotification,
    getProductDetails,
    getShippingList,
    isLogined,
    MallInfo,
    MallNotification,
    MallUserInfoType,
    Mileage,
    ProductDetailsType,
    ShippingAddressBookType,
    OrderDetail,
    createAccountByToken,
    getMallBusinessInfo,
    MallBusinessInfoType,
    createOrderSheet,
    CreateOrderSheetReturnType,
    getOrderList,
    UserOrder,
    getInquiryList,
    Inquiries,
    isIslandMountain,
    // getMallSalesPolicy,
    SalesPolicyType,
    getMallUserIdByToken,
    GroupPurchaseOrderType,
    getGroupPurchaseOrderList,
    isJejuShippingCost,
    getMallPathWithProductGroupId,
    getOrderCouponList,
    OnlineCouponListType,
    createOrderSheetV2,
    getOrderDetailInfoV2,
    OrderDetailV2,
    getOrderListV2,
    UserOrderV2,
    getNotLoginOrderV2,
    getCartListV2,
    getProductOptionsV2,
    getUserCouponList,
    getUserCouponAvailableList,
    UserCouponListType,
} from './services/mallUser.service';
import { useAnonymousUserStore, useUserStore } from './store/userStore';
import { PurchaseDrawerStoreState, usePurchaseDrawerStore } from './store/purchaseDrawerStore';
import {
    checkIsMallUser,
    checkRefreshToken,
    checkRefreshTokenBool,
    getTokenByAnonymous,
    getUserInfo,
    logOut,
    setReferrerRefreshToken,
    setReferrerToken,
    socialLogin,
} from './services/auth.service';
import { axiosApi } from './helpers/api.helper';
import { useSpaceHomeStore } from './store/spaceHomeStore';
import MainPage from './pages/LazyMall/MainPage';
import Logout from './pages/LazyMall/Auth/Logout';
import SpaceHomeRe from './pages/SpaceHomeRebuild';
import LazyRouteElement from './LazyRouteElement';
import SocialLoginComponent from './pages/LazyMall/Auth/SocialLogin';
import { useOrderNPayStore } from './store/orderNPayStore';
import { useOrderNumberStore } from './store/orderNumberStore';
const LazyRefundInfo = lazy(() => import('./pages/LazyMall/Refund/RefundInfo').then((module) => module));
const LazyPersonalInfo = lazy(() => import('./pages/LazyMall/Auth/PersonalInfo').then((module) => module));
const LazyDestinationList = lazy(() => import('./pages/LazyMall/Destination/DestinationList').then((module) => module));
const LazyDestinationAddition = lazy(() =>
    import('./pages/LazyMall/Destination/DestinationAddition').then((module) => module),
);
const LazyMyPage = lazy(() => import('./pages/LazyMall/MyPage').then((module) => module));
const LazySearch = lazy(() => import('./pages/LazyMall/ProductSearch').then((module) => module));
const LazyInquiry = lazy(() => import('./pages/LazyMall/Inquiry/Inquiry').then((module) => module));
const LazyTrackingInfo = lazy(() => import('./pages/LazyMall/TrackingInfo').then((module) => module));
const LazyProductDetails = lazy(() => import('./pages/LazyMall/ProductDetailsV2').then((module) => module));
const LazyOrderDetailInfo = lazy(() => import('./pages/LazyMall/Order/OrderDetailInfoV2').then((module) => module));
const LazyOrderListV2 = lazy(() => import('./pages/LazyMall/Order/OrderNShippingInfoV2').then((module) => module));
const LazyOrderNPay = lazy(() => import('./pages/LazyMall/Payment/OrderNPay').then((module) => module));
const LazyRefundRequest = lazy(() => import('./pages/LazyMall/Refund/RefundRequestV2').then((module) => module));
const LazyAdditionalPay = lazy(() => import('./pages/LazyMall/Payment/AdditionalPay').then((module) => module));
const LazyFAQ = lazy(() => import('./pages/LazyMall/FAQ').then((module) => module));
const LazyNotice = lazy(() => import('./pages/LazyMall/NoticeList').then((module) => module));
const LazyNoticeDetail = lazy(() => import('./pages/LazyMall/NoticeDetail').then((module) => module));
const LazyNotLoginOrder = lazy(() => import('./pages/LazyMall/NotLoginShipping').then((module) => module));
const LazyAdditionalPayResult = lazy(() =>
    import('./pages/LazyMall/Payment/AdditionalPayResult').then((module) => module),
);
const LazyPayResult = lazy(() => import('./pages/LazyMall/Payment/PayResult').then((module) => module));
const LazyRegister = lazy(() => import('./pages/LazyMall/Auth/Register').then((module) => module));
const LazyLogin = lazy(() => import('./pages/LazyMall/Auth/Login').then((module) => module));
const LazyRegisterRenew = lazy(() => import('./pages/LazyMall/Auth/RegisterRenew').then((module) => module));
import LazyMallHome from './pages/LazyMall/Home/LazyMallHome';
const LazyNewCart = lazy(() => import('./pages/LazyMall/Cart/NewCartV2'));
const LazyCancelAction = lazy(() => import('./pages/LazyMall/CancelActionsV2'));
const LazyRecipes = lazy(() => import('./pages/Recipes').then((module) => module));
const LazyRecipeDetail = lazy(() => import('./pages/Recipes/RecipeDetail').then((module) => module));
const LazyCoupon = lazy(() => import('./pages/LazyMall/CouponPage').then((module) => module));

import ProductDetailPage from './pages/LazyMall/ProductDetails';
import { CssVarsProvider } from '@mui/joy';
import theme from './pages/LazyMall/theme/defaultTheme';
import { Box, CssBaseline } from '@mui/material';
import Nav from './pages/LazyMall/Nav';
import HomeContainer from './pages/LazyMall/Home/HomeContainer';
import config from './config/config';
import SpaceHomeV2 from './pages/SpaceHomeV2';
import { useSourcingReferrerStore } from './store/sourcingReferrerStore';
import { getShoppingPoint, getShoppingPointPolicy, getUserPoint } from './services/point.service';
import HookingResult from './pages/HookingResult';
import { toast } from 'react-toastify';
import { getRecipeCategories, getRecipeDetail } from './services/recipe.service';

const LazyHookingResult = lazy(() => import('./pages/HookingResult').then((module) => module));

const env = import.meta.env.VITE_SET_ENV || 'DEV';

const router = createBrowserRouter([
    {
        path: '/logout',
        element: <Logout />,
        errorElement: <ErrorComponent />,
    },
    {
        path: 'social/:socialName',
        element: <SocialLoginComponent />,
        errorElement: <ErrorComponent />,
        loader: async ({ params }) => {
            const { socialName: social } = params;
            const queryString = new URLSearchParams(window.location.search);
            const path = String(queryString.get('state')).split('/')[2];
            // console.log('sns path:::', path)
            try {
                if (isLogined()) {
                    console.log('session is alive');
                    return redirect(!!path ? `/mall/${path}` : `/mall`);
                }
                return { social };
            } catch (error) {
                throw error;
            }
        },
    },
    {
        path: '/app-ads.txt',
        element: <p>google.com, pub-2774361938949385, DIRECT, f08c47fec0942fa0</p>,
    },
    {
        path: '/:path',
        element: <SpaceHomeV2 />,
        loader: spaceHomeV2Loader,
        errorElement: <ErrorComponent />,
    },
    {
        path: '/2na2jun_mom/recipes',
        element: <LazyRouteElement element={<LazyRecipes />} />,
        loader: recipesLoader,
    },
    {
        path: '/2na2jun_mom/recipes/detail/:recipeId',
        element: <LazyRouteElement element={<LazyRecipeDetail />} />,
        loader: recipeDetailLoader,
    },
    {
        path: '/mall',
        element: <LazyMallHome />,
        errorElement: <ErrorComponent />,
        loader: async (to) => {
            return await mallMainLoaderHome(to);
        },
    },
    {
        path: 'mall/product-details/:productId',
        element: (
            <>
                <HomeContainer>
                    <LazyRouteElement element={<LazyProductDetails />} />
                </HomeContainer>
            </>
        ),
        loader: productDetailsLoader,
        errorElement: <ErrorComponent />,
    },
    {
        path: '/mall/register',
        element: (
            <HomeContainer>
                <LazyRouteElement element={<LazyRegister />} />
            </HomeContainer>
        ),
        loader: pageSessionCheckLoader,
    },
    {
        path: '/mall/login',
        element: (
            <HomeContainer>
                <LazyRouteElement element={<LazyLogin />} />
            </HomeContainer>
        ),
        loader: pageSessionCheckLoader,
    },
    {
        path: '/mall/register-renew',
        element: (
            <HomeContainer>
                <LazyRouteElement element={<LazyRegisterRenew />} />
            </HomeContainer>
        ),
    },
    {
        path: 'vendor',
        children: [
            { path: 'product-list', element: <>product-list</> },
            { path: 'product-details', element: <>product-details</> },
        ],
    },
    {
        path: '/hooking-result/:resultId',
        element: <LazyRouteElement element={<LazyHookingResult />} />,
        loader: hookingResultLoader,
    },
    // {
    //     path: '/mall/recipes',
    //     loader: async () => {
    //         return redirect('/2na2jun_mom/recipes')
    //     }
    // },
    {
        path: '/mall/:path', //예시 path: flowing__
        element: <LazyMall />,
        errorElement: <ErrorComponent />,
        // loader: mallFooterInfoLoader,
        children: [
            {
                path: '',
                element: (
                    <>
                        {/* <MallBanner />
                        <ProductList /> */}
                        <MainPage />
                    </>
                ),
                loader: mallMainLoader,
            },
            {
                path: 'refund-info',
                loader: pageSessionCheckLoader,
                element: <LazyRouteElement element={<LazyRefundInfo />} />,
            },
            {
                path: 'personal-info',
                element: <LazyRouteElement element={<LazyPersonalInfo />} />,
                loader: perosonalInfoLoader,
            },
            {
                path: 'destination-list',
                element: <LazyRouteElement element={<LazyDestinationList />} />,
                loader: destinationListLoader,
            },
            {
                path: 'destination-addition',
                element: <LazyRouteElement element={<LazyDestinationAddition />} />,
                loader: destinationAdditionLoader,
            },
            {
                path: 'mypage',
                element: <LazyRouteElement element={<LazyMyPage />} />,
                loader: mypageLoader,
            },
            {
                path: 'search',
                element: <LazyRouteElement element={<LazySearch />} />,
                loader: pageSessionCheckLoader,
            },
            {
                path: 'redirect-pay-success',
                element: <b></b>,
                loader: async (to) => {
                    const {
                        api: { mall_api },
                    } = config;
                    const orderSessionDate = new URL(to.request.url).searchParams.get('ors') || '';
                    const orderId = new URL(to.request.url).searchParams.get('orderId') || '';
                    const paymentKey = new URL(to.request.url).searchParams.get('paymentKey') || '';
                    const amount = new URL(to.request.url).searchParams.get('amount') || '';
                    return redirect(
                        `${mall_api}/common/payment/pg/succeed?ors=${orderSessionDate}&orderId=${orderId}&paymentKey=${paymentKey}&amount=${amount}`,
                    );
                },
            },
            {
                path: 'redirect-pay-fail',
                element: <></>,
                loader: async (to) => {
                    const {
                        api: { mall_api },
                    } = config;
                    const orderSessionDate = new URL(to.request.url).searchParams.get('ors') || '';
                    const orderId = new URL(to.request.url).searchParams.get('orderId') || '';
                    const code = new URL(to.request.url).searchParams.get('code') || '';
                    const message = new URL(to.request.url).searchParams.get('message') || '';
                    return redirect(
                        `${mall_api}/common/payment/pg/fail?ors=${orderSessionDate}&code=${code}&message=${message}&orderId=${orderId}`,
                    );
                },
            },
            {
                path: 'redirect-additional-pay-success',
                element: <b></b>,
                loader: async (to) => {
                    const {
                        api: { mall_api },
                    } = config;
                    const orderId = new URL(to.request.url).searchParams.get('orderId') || '';
                    const paymentKey = new URL(to.request.url).searchParams.get('paymentKey') || '';
                    const amount = new URL(to.request.url).searchParams.get('amount') || '';
                    return redirect(
                        `${mall_api}/common/payment/pg/extra-charge/succeed?orderId=${orderId}&paymentKey=${paymentKey}&amount=${amount}`,
                    );
                },
            },
            {
                path: 'redirect-additional-pay-fail',
                element: <></>,
                loader: async (to) => {
                    const {
                        api: { mall_api },
                    } = config;
                    const orderId = new URL(to.request.url).searchParams.get('orderId') || '';
                    const code = new URL(to.request.url).searchParams.get('code') || '';
                    const message = new URL(to.request.url).searchParams.get('message') || '';
                    return redirect(
                        `${mall_api}/common/payment/pg/extra-charge/fail?code=${code}&message=${message}&orderId=${orderId}`,
                    );
                },
            },
            {
                path: 'cart',
                element: <LazyRouteElement element={<LazyNewCart />} />,
                loader: newCartLoader,
            },
            {
                path: 'inquiry',
                element: <LazyRouteElement element={<LazyInquiry />} />,
                loader: myInquiryListLoader,
            },
            {
                path: 'tracking-info/:invoiceNumber',
                element: <LazyRouteElement element={<LazyTrackingInfo />} />,
                loader: pageSessionCheckLoader,
            },
            {
                path: 'product-details/:productId',
                element: <LazyRouteElement element={<LazyProductDetails />} />,
                loader: productDetailsLoader,
            },
            {
                path: 'order-detail-info/:orderGroupId',
                element: <LazyRouteElement element={<LazyOrderDetailInfo />} />,
                loader: orderDetailInfoLoader,
            },
            {
                path: 'order-n-shipping-info/:offset',
                element: <LazyRouteElement element={<LazyOrderListV2 />} />,
                loader: async (params) => {
                    return await orderListLoaderV2(params, false);
                },
            },
            {
                path: 'order-n-pay',
                element: <LazyRouteElement element={<LazyOrderNPay />} />,
                loader: orderNPayLoader,
            },
            {
                path: 'refund-list/:offset',
                element: <LazyRouteElement element={<LazyOrderListV2 />} />,
                loader: async (params) => {
                    return await orderListLoaderV2(params, true);
                },
            },
            {
                path: 'refund/:mallOrderId',
                element: <LazyRouteElement element={<LazyRefundRequest />} />,
                loader: async () => {
                    try {
                        isLogined() && (await sessionCheckFunc().then((r) => r));
                        return [];
                    } catch (error) {
                        return [];
                        // throw error
                    }
                },
            },
            {
                path: 'coupon',
                element: <LazyRouteElement element={<LazyCoupon />} />,
                loader: async (params) => {
                    return await userCouponListLoader(params);
                },
            },
            // {
            //     path: 'refund-detail/*',
            //     element: <RefundDetail />,
            // },
            {
                path: 'additional-pay/:orderId',
                element: <LazyRouteElement element={<LazyAdditionalPay />} />,
                loader: additionalPayLoader,
            },
            {
                path: 'faq/*',
                element: <LazyRouteElement element={<LazyFAQ />} />,
                loader: pageSessionCheckLoader,
            },
            {
                path: 'notice',
                element: <LazyRouteElement element={<LazyNotice />} />,
                loader: noticeListLoader,
            },
            {
                path: 'notice-detail/:noticeId',
                element: <LazyRouteElement element={<LazyNoticeDetail />} />,
                loader: pageSessionCheckLoader,
            },
            {
                path: 'not-login-shipping',
                element: <LazyRouteElement element={<LazyNotLoginOrder />} />,
                loader: pageSessionCheckLoader,
            },
            {
                path: 'additional-pay-result',
                element: <LazyRouteElement element={<LazyAdditionalPayResult />} />,
                loader: additionalPayResultLoader,
            },
            {
                path: 'pay-result',
                element: <LazyRouteElement element={<LazyPayResult />} />,
                loader: payResultLoader,
            },
            {
                path: 'cancel/:groupId',
                element: <LazyRouteElement element={<LazyCancelAction />} />,
                loader: cancelRequestLoader,
            },
            {
                path: 'register',
                element: <LazyRouteElement element={<LazyRegister />} />,
                loader: pageSessionCheckLoader,
            },
            {
                path: 'login',
                element: <LazyRouteElement element={<LazyLogin />} />,
                loader: pageSessionCheckLoader,
            },
            {
                path: 'register-renew',
                element: <LazyRouteElement element={<LazyRegisterRenew />} />,
            },
        ],
    },
    {
        path: '/*',
        element: <ErrorComponent />,
        loader: async () => {
            throw { status: 404 };
        },
    },
]);

async function cancelRequestLoader({ params }) {
    try {
        isLogined() && (await sessionCheckFunc().then((r) => r));
        const { groupId } = params;
        const { mallUserId: anonymousId } = useAnonymousUserStore.getState();
        const mallUserId = useUserStore.getState().mallUserId;
        const data = await getOrderDetailInfoV2(isLogined() ? mallUserId : anonymousId, groupId).then((r) => {
            if (r.status !== 200) throw r;
            return r;
        });
        return data;
    } catch (error) {
        throw error;
    }
}

export interface CancelRequestLoaderType {
    data: OrderDetail;
}

async function spaceHomeLoader({ params }) {
    try {
        await sessionCheckFunc().then((r) => r);
        const { path } = params;
        const profile = await getProfileWithPath(path || '');
        if (profile?.status == 204) {
            throw new Error('스페이스홈이 없음');
        }

        const spaceHomeData = await getSpaceHome(profile?.user_id);
        useSpaceHomeStore.setState(() => ({ ...spaceHomeData }));
        return spaceHomeData;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

async function spaceHomeRebuildLoader({ params, request }) {
    // console.time('loader start')
    const { path } = params;
    try {
        await sessionCheckFunc().then((r) => r);
        const { user_id, user_img_url } = await getSpaceProfileByPath(path)
            .then((r) => {
                if (r.status === 201) throw new Error('존재하지 않는 유저');
                if (r.status !== 200) throw new Error('잘못된 접근');
                return r.item;
            })
            .catch((error) => {
                if (error?.statusCode === 400 && error?.place_holder === '존재하지 않는 path입니다')
                    throw { statusCode: 404 };
                else throw error;
            });
        const design_data = await getSpaceHomeData(user_id).then((r) => {
            return { ...r.item, user_img_url };
        });
        const item_list = getSpaceHomeSpeedBlockData(user_id).then((r) => {
            return r.data.item_list;
        });
        return defer({
            design_data,
            item_list,
            user_id,
        });
    } catch (error) {
        throw error;
    } finally {
        // console.timeEnd('loader start')
    }
}
async function spaceHomeV2Loader({ params, request }) {
    const { path } = params;
    try {
        await sessionCheckFunc().then((r) => r);
        const { user_id, is_mall_opened = false, nickname = '' } = await getSpaceProfileByPath(path)
            .then((r) => {
                if (r.status === 201) throw new Error('존재하지 않는 유저');
                if (r.status !== 200) throw new Error('잘못된 접근');
                return r.item;
            })
            .catch((error) => {
                if (
                    error?.statusCode === 400 &&
                    (error?.place_holder === '존재하지 않는 path입니다' ||
                        error?.message === '존재하지 않는 path입니다')
                )
                    throw { statusCode: 'path-not-valid' };
                else throw error;
            });
        const design_data = await getSpaceHomeDesignDataV2(user_id).then((r) => {
            return { ...r?.item, design_type: r?.item?.design_type || 'gonggu', path };
        });
        const item_list = getEventBlockListV2(user_id)
            .then((r) => r)
            .catch(() => []);
        return defer({
            design_data,
            item_list,
            user_id,
            is_mall_opened,
            nickname,
        });
    } catch (error) {
        throw error;
    } finally {
        // console.timeEnd('loader start')
    }
}

async function recipesLoader() {
    try {
        await sessionCheckFunc().then((r) => r);
        // const recipes = await getRecipes()
        // return recipes
        return defer({
            recipeCategories: getRecipeCategories(),
        });
    } catch (error) {
        throw error;
    }
}

async function recipeDetailLoader({ params }) {
    try {
        const { recipeId = '' } = params;
        await sessionCheckFunc().then((r) => r);
        return defer({
            recipeDetail: getRecipeDetail(recipeId)
                .then((r) => r[0] || {})
                .catch(() => {}),
        });
    } catch (error) {
        throw error;
    }
}
async function mallMainLoader({ params }) {
    try {
        // await fetchNStoreAnonymousTokenNId()
        await sessionCheckFunc().then((r) => r);
        const { path } = params;
        const { mallId } = await getMallId(path);
        const { mallInfo } = await getMallInfo(mallId);
        const { notificationList } = await getPinedNotification(mallId);
        const { mallBusinessInfo } = await getMallBusinessInfo(mallId).then((r) => r);
        const shopName = await getMallInfo(mallId).then((r) => {
            return r.mallInfo.name;
        });
        const { tagList } = await getMallTagList(mallId).then((r) => r);
        const tagNames = ['전체', ...tagList.filter(({ display }) => display)?.map(({ name }) => name)];

        return {
            mallInfo,
            tagNames,
            notificationList,
            mallBusinessInfo,
            shopName,
            mallId,
        };
    } catch (error) {
        console.log(error);
        if (error?.['status'] === 422 || error?.['error'] === 'Unprocessable Entity') {
            throw { statusCode: 404 };
        } else if (error?.['status'] === 403) {
            throw { statusCode: 403 };
        } else {
            return {
                mallInfo: {},
                tagNames: [],
                notificationList: [],
                mallBusinessInfo: {},
                shopName: '',
                mallId: '',
            };
        }
    }
}
async function mallMainLoaderHome({ params }) {
    try {
        // await fetchNStoreAnonymousTokenNId()
        await sessionCheckFunc().then((r) => r);
        if (isLogined()) {
            const mallUserId = useUserStore.getState().mallUserId || '';
            const { realName } = await getMallUserInfo(mallUserId);
            console.log(realName);
            return {
                userName: realName,
            };
        } else {
            return {
                userName: '',
            };
        }
        // // const { path } = params;
        // const path = 'real-edwin'
        // const { mallId } = await getMallId(path);
        // const { mallInfo } = await getMallInfo(mallId);
        // const { notificationList } = await getPinedNotification(mallId);
        // const { mallBusinessInfo } = await getMallBusinessInfo(mallId).then(r => r)
        // const shopName = await getMallInfo(mallId).then(r => {
        //     return r.mallInfo.name
        // })
        // // const { tagList } = await getMallTagList(mallId).then(r => r)
        // // const tagNames = ['전체', ...tagList.filter(({ display }) => display)?.map(({ name }) => name)];
        // const result = {
        //     mallInfo,
        //     // tagNames,
        //     notificationList,
        //     mallBusinessInfo,
        //     shopName,
        //     mallId
        // }
        // console.log('result!!', result)
        // return result;
    } catch (error) {
        console.log(error);
        if (error?.['status'] === 422 || error?.['error'] === 'Unprocessable Entity') {
            throw { statusCode: 404 };
        } else if (error?.['status'] === 403) {
            throw { statusCode: 403 };
        } else {
            return {
                mallInfo: {},
                tagNames: [],
                notificationList: [],
                mallBusinessInfo: {},
                shopName: '',
                mallId: '',
            };
        }
    }
}
async function vendorProductListLoader() {}
async function vendorProductDetailsLoader() {}
async function hookingResultLoader({ params, request }) {
    if (env !== 'DEV') {
        toast.info('잘못된 접근입니다.');
        return redirect(`/`);
    }
    const { resultId = '' } = params;
    try {
        await sessionCheckFunc(false).then((r) => r);
        // const {} = await
        return true;
    } catch (error) {
        throw error;
    }
}

// async function mallFooterInfoLoader({ params }) {
//     const { path } = params;
//     try {
//         // await fetchNStoreAnonymousTokenNId()
//         // await sessionCheckFunc()

//         const { mallId } = await getMallId(path);
//         const {mallBusinessInfo} = await getMallBusinessInfo(mallId).then(r => {
//             return r
//         })
//         const shopName = await getMallInfo(mallId).then(r => {
//             return r.mallInfo.name
//         })
//         const { mallInfo } = await getMallInfo(mallId).then(r => r)
//         return { mallBusinessInfo, shopName, mallId, mallInfo }
//     } catch (err) {
//         throw err
//     }
// }

async function productDetailsLoader({ params, request }) {
    try {
        await sessionCheckFunc().then((r) => r);
        const { productId } = params;
        const path = await getMallPathWithProductGroupId(productId).catch((error) => {
            if (error?.status === 404 || error?.statusCode === 404) throw { statusCode: 'product-not-valid' };
            throw error;
        });

        const { mallId } = await getMallId(path);
        const { mallBusinessInfo } = await getMallBusinessInfo(mallId).then((r) => {
            return r;
        });
        const { mallInfo } = await getMallInfo(mallId);
        const shopName = mallInfo.name;

        const userPoint = !!isLogined()
            ? await getUserPoint()
                  .then((r) => r?.point || 0)
                  .catch(() => 0)
            : 0;
        const { shoppingPoint } = !!isLogined()
            ? await getShoppingPoint().catch(() => ({ shoppingPoint: 0 }))
            : { shoppingPoint: 0 };
        const shoppingPointPolicy = !!isLogined() ? await getShoppingPointPolicy() : {};
        const productDetails = await getProductDetails(mallId, productId)
            .then((r) => r)
            .catch((error) => {
                console.log(error);
                if (error?.status === 404 || error?.statusCode === 404) throw { statusCode: 'product-not-valid' };
                throw error;
            });

        return {
            productDetails,
            mallInfo,
            mallBusinessInfo,
            shopName,
            request,
            userPoint,
            shoppingPoint,
            shoppingPointPolicy,
            path,
        };
    } catch (error) {
        throw error;
    }
}

async function orderNPayLoader({ params, request }: LoaderFunctionArgs) {
    const orderSessionDate = new URL(request.url).searchParams.get('ors') || '';
    try {
        await sessionCheckFunc().then((r) => r);
        const isSetProduct = useOrderNPayStore.getState()[orderSessionDate]?.isSetProduct;
        const products = isSetProduct
            ? useOrderNPayStore.getState()[orderSessionDate]?.setProductList
            : useOrderNPayStore.getState()[orderSessionDate]?.productList;
        if (!products) {
            alert('주문 정보 조회에 실패하였습니다. 다시 한번 시도해 주세요.');
            return redirect(`/mall/${params?.path || ''}`);
        }
        const { mallId } = await getMallId(params?.path || '');

        const { pgType, pgBusinessType } = await getMallInfo(mallId)
            .then((r) => {
                return r?.mallInfo || { pgType: '', pgBusinessType: '' };
            })
            .catch(() => {
                return { pgType: '', pgBusinessType: '' };
            });

        if (isLogined()) {
            const mallUserId = useUserStore.getState().mallUserId;
            const userInfo = await getMallUserInfo(mallUserId);
            let { shippingAddressBookList } = await getShippingList(mallUserId);
            shippingAddressBookList = shippingAddressBookList?.sort((post) => (post.isDefaultShippingAddress ? -1 : 1));
            const { mileageList } = await getMilageList(mallId, mallUserId);
            const userPoint = await getUserPoint()
                .then((r) => r?.point || 0)
                .catch(() => 0);
            const { shoppingPoint } = await getShoppingPoint().catch(() => ({ shoppingPoint: 0 }));
            const shoppingPointPolicy = await getShoppingPointPolicy();
            const { item } = await createOrderSheetV2(mallUserId, mallId, {
                setProducts: useOrderNPayStore
                    .getState()
                    [orderSessionDate].setProductList.map(({ productIds, numberOfPicked, productGroupId }) => ({
                        productGroupId,
                        productIds,
                        amount: numberOfPicked,
                    })),
                products: useOrderNPayStore
                    .getState()
                    [orderSessionDate].productList.map(({ productId, numberOfPicked, productGroupId }) => ({
                        productGroupId,
                        productId,
                        amount: numberOfPicked,
                    })),
                addonProducts: useOrderNPayStore
                    .getState()
                    [orderSessionDate].addonProductList.map(
                        ({ productId, numberOfPicked, productGroupId, optionName, optionValue }) => ({
                            productGroupId,
                            productId,
                            amount: numberOfPicked,
                            optionName,
                            optionValue,
                        }),
                    ),
                ownerType: products[0].ownerType,
            })
                .then((r) => r)
                .catch(() => {
                    throw 'session product data is undefined';
                });
            // const { salesPolicyInfo } = await getMallSalesPolicy(
            //     mallId, orderInfo.productList[0].representProductId
            // ).then(r => {
            //     if (r.status !== 200) throw r
            //     return r
            // })

            const { items: couponList } = await getUserCouponAvailableList({
                mallUserId,
                productGroupIds: [
                    ...useOrderNPayStore
                        .getState()
                        [orderSessionDate].setProductList.map(({ productGroupId }) => productGroupId),
                    ...useOrderNPayStore
                        .getState()
                        [orderSessionDate].productList.map(({ productGroupId }) => productGroupId),
                ],
                orderAmount: item?.paymentInfo?.totalCharge,
            });

            return {
                shippingAddressBookList,
                mileageList: mileageList.filter(({ mallId }) => mallId === mallId),
                userInfo,
                mallId,
                orderInfo: item,
                couponList,
                // salesPolicyInfo,
                state: 'success',
                pgType,
                pgBusinessType,
                shoppingPoint,
                userPoint,
                shoppingPointPolicy,
            };
        } else {
            const mallUserId = useAnonymousUserStore.getState().mallUserId;
            // console.log('mallId :>> ', mallId);
            // console.log('mallUserId :>> ', mallUserId);
            const { item } = await createOrderSheetV2(mallUserId, mallId, {
                setProducts: useOrderNPayStore
                    .getState()
                    [orderSessionDate].setProductList.map(({ productIds, numberOfPicked, productGroupId }) => ({
                        productGroupId,
                        productIds,
                        amount: numberOfPicked,
                    })),
                products: useOrderNPayStore
                    .getState()
                    [orderSessionDate].productList.map(({ productId, numberOfPicked, productGroupId }) => ({
                        productGroupId,
                        productId,
                        amount: numberOfPicked,
                    })),
                addonProducts: useOrderNPayStore
                    .getState()
                    [orderSessionDate].addonProductList.map(
                        ({ productId, numberOfPicked, productGroupId, optionName, optionValue }) => ({
                            productGroupId,
                            productId,
                            amount: numberOfPicked,
                            optionName,
                            optionValue,
                        }),
                    ),
                ownerType: products[0].ownerType,
            })
                .then((r) => r)
                .catch(() => {
                    throw 'session product data is undefined';
                });
            // const { salesPolicyInfo } = await getMallSalesPolicy(
            //     mallId, orderInfo.productList[0].representProductId
            // ).then(r => {
            //     if (r.status !== 200) throw r
            //     return r
            // })

            return {
                shippingAddressBookList: [],
                mileageList: [],
                userInfo: {
                    id: mallUserId,
                },
                mallId,
                orderInfo: item,
                // salesPolicyInfo,
                state: 'success',
                pgType,
                pgBusinessType,
                shoppingPoint: 0,
                userPoint: 0,
                shoppingPointPolicy: {},
            };
        }
    } catch (error) {
        const e = error as
            | {
                  status: number;
                  data: {
                      message: string;
                      placeHolder: string;
                  };
              }
            | string;
        /**
            @TODO
                `재고 부족에 대한 처리
         */
        /* if (e.status === 422) {
            재고 부족에 대한 처리
        } */
        console.log('error :>> ', error);
        if (error === 'session product data is undefined') {
            alert('주문 정보 조회에 실패하였습니다. 다시 한번 시도해 주세요.');
            return redirect(`/mall/${params?.path || ''}`);
        } else throw error;
    }
}

async function pageSessionCheckLoader() {
    try {
        await sessionCheckFunc().then((r) => r);
        return [];
    } catch (error) {
        return [];
        // throw error
    }
}

async function newCartLoader(to) {
    try {
        await sessionCheckFunc().then((r) => r);
        const mallUserId = useUserStore.getState().mallUserId;
        const { mallId } = await getMallId(to.params?.path || '');
        if (isLogined()) {
            const { item } = await getCartListV2(mallId, mallUserId);
            return { mallId, cartInfo: item };
        } else return { mallId, cartInfo: {} };
    } catch (err) {
        return {
            mallId: '',
            cartInfo: {
                mallId: '',
                sellerProductList: [],
                vendorProductList: [],
            },
        };
    }
}

async function destinationListLoader({ params }) {
    if (!isLogined()) {
        alert('로그인이 필요한 페이지입니다.');
        return redirect(`/mall/${params.path}/login?referer=/mall/${params.path}/destination-list`);
    }
    try {
        await sessionCheckFunc().then((r) => r);
        const mallUserId = useUserStore.getState().mallUserId;
        const { shippingAddressBookList } = await getShippingList(mallUserId);

        return {
            shippingAddressBookList: shippingAddressBookList?.sort((post) => {
                return post.isDefaultShippingAddress ? -1 : 1;
            }),
        };
    } catch (error) {
        throw error;
    }
}

async function destinationAdditionLoader({ params }) {
    if (!isLogined()) {
        alert('로그인이 필요한 페이지입니다.');
        return redirect(`/mall/${params.path}/login?referer=/mall/${params.path}/destination-addition`);
    }
    const defaultReturn = {
        userInfo: {
            id: '',
            email: '',
            phoneNumber: '',
            realName: '',
            smsMarketingConsented: false,
            emailMarketingConsented: false,
        } as MallUserInfoType,
    };
    try {
        await sessionCheckFunc().then((r) => r);
        const mallUserId = useUserStore.getState().mallUserId;
        const userInfo = await getMallUserInfo(mallUserId);

        return {
            userInfo,
        };
    } catch (error) {
        console.log(error);
        if (error?.['status'] === 403 || error?.['status'] === 401) throw error;
        else return defaultReturn;
    }
}

async function mypageLoader({ params }: LoaderFunctionArgs) {
    try {
        await sessionCheckFunc();
        const { mallId } = await getMallId(params?.path || '');
        if (isLogined()) {
            const mallUserId = useUserStore.getState().mallUserId;
            const userInfo = await getMallUserInfo(mallUserId)
                .then((r) => r)
                .catch(() => {
                    throw 'issue';
                });
            const { mileageList } = await getMilageList(mallId, mallUserId)
                .then((r) => r)
                .catch(() => {
                    throw 'issue';
                });
            return {
                userInfo: userInfo,
                mileage: mileageList[0].mileageDeposit,
                mallId,
                state: 'success',
            };
        } else {
            return {
                userInfo: null,
                mileage: 0,
                mallId,
                state: 'success',
            };
        }
    } catch (error) {
        return {
            userInfo: null,
            mileage: 0,
            mallId: '',
            state: 'fail',
        };
    }
}

async function perosonalInfoLoader({ params }) {
    if (!isLogined()) {
        alert('로그인이 필요한 페이지입니다.');
        return redirect(`/mall/${params.path}/login?referer=/mall/${params.path}/personal-info`);
    }
    try {
        await sessionCheckFunc().then((r) => r);
        const mallUserId = useUserStore.getState().mallUserId;
        const userInfo = await getMallUserInfo(mallUserId);
        const shippingList = await getShippingList(mallUserId).then((r) => {
            return r.shippingAddressBookList;
        });
        return { userInfo, shippingList };
    } catch (error) {
        console.log(error);
        if (error?.['status'] === 403 || error?.['status'] === 401) throw error;
        else return { userInfo: {}, shippingList: [] };
    } finally {
    }
}

async function additionalPayLoader({ params }) {
    try {
        const checkSession = sessionStorage.getItem('Additional-pay-session');
        if (String(checkSession) !== 'session-true') {
            alert('잘못된 접근입니다.');
            return redirect(`/mall/${params.path}`);
        }
        await sessionCheckFunc().then((r) => r);
        const info = await getExtraChargeInfo(params.orderId).then((r) => {
            return r;
        });
        return {
            extraChargeInfo: { ...info.extraChargeInfo },
        };
    } catch (error) {
        throw error;
    }
}

async function additionalPayResultLoader() {
    const queryString = new URLSearchParams(window.location.search);
    const transactionId = String(queryString.get('transactionId'));
    const accountNumber = String(queryString.get('accountNumber'));
    const bank = String(queryString.get('bank'));
    const customerName = String(queryString.get('customerName'));
    const dueDate = String(queryString.get('dueDate'));
    const failMessage = String(queryString.get('failMessage') || '');
    const paramData = { accountNumber, bank, customerName, dueDate, failMessage };

    try {
        await sessionCheckFunc().then((r) => r);
        if (!!failMessage) {
            return { payResult: {}, paramData };
        } else {
            const payResult = await getAdditionalPayResult(transactionId).then((r) => {
                return r.extraChargeInfo;
            });
            return { payResult, paramData };
        }
    } catch (error) {
        return { payResult: {}, paramData };
    }
}

async function payResultLoader({ request, params }: LoaderFunctionArgs) {
    const queryString = new URLSearchParams(request?.url.split('?')[1]);
    const orderGroupId = String(queryString.get('orderGroupId'));
    const orderGroupNumber = String(queryString.get('orderGroupNumber'));
    const accountNumber = String(queryString.get('accountNumber'));
    const bank = String(queryString.get('bank'));
    const customerName = String(queryString.get('customerName'));
    const depositor = String(queryString.get('depositor'));
    const dueDate = String(queryString.get('dueDate'));
    const failMessage = String(queryString.get('failMessage') || '');
    const orderSessionDate = queryString.get('ors') || new Date().getTime().toString();
    const paramData = { accountNumber, bank, customerName, dueDate, failMessage, depositor };
    const { update } = useOrderNPayStore.getState();
    const payData = { ...useOrderNPayStore.getState() };
    delete payData[orderSessionDate];
    update(payData);
    try {
        await sessionCheckFunc().then((r) => r);
        const { path = '' } = params;
        const { mallId } = await getMallId(path);
        if (isLogined()) {
            const { mallId } = await getMallId(params?.path || '');
            const { pgType } = await getMallInfo(mallId)
                .then((r) => {
                    return r?.mallInfo || { pgType: '' };
                })
                .catch(() => {
                    return { pgType: '' };
                });
            const { mallUserId } = useUserStore.getState();
            const orderDetailInfoV2 = await getOrderDetailInfoV2(mallUserId, orderGroupId).then((r) => {
                return r.item;
            });
            const couponList = await getOrderCouponList(mallUserId, mallId, orderGroupId)
                .then((r) => r)
                .catch(() => []);
            return { orderDetailInfo: orderDetailInfoV2, paramData, couponList, pgType };
        } else {
            const { mallUserId } = useAnonymousUserStore.getState();
            const { mallId } = await getMallId(params?.path || '');
            const { pgType } = await getMallInfo(mallId)
                .then((r) => {
                    return r?.mallInfo || { pgType: '' };
                })
                .catch(() => {
                    return { pgType: '' };
                });
            const { item } = await getNotLoginOrderV2(orderGroupNumber).then((r) => {
                if (r.status !== 200) throw r;
                return r;
            });
            const couponList = await getOrderCouponList(mallUserId, mallId, orderGroupId)
                .then((r) => r)
                .catch(() => []);
            return { orderDetailInfo: item, paramData, couponList, pgType };
        }
    } catch (error) {
        console.log('error :>> ', error);
        return { orderDetailInfo: {}, paramData, couponList: [], pgType: '' };
    }
}

async function orderListLoader({ params }, isIssue: 'yes' | '') {
    if (!isLogined()) {
        alert('로그인이 필요한 페이지입니다.');
        if (isIssue == '') {
            return redirect(`/mall/${params.path}/login?referer=/mall/${params.path}/order-n-shipping-info/1`);
        } else {
            return redirect(`/mall/${params.path}/login?referer=/mall/${params.path}/refund-list/1`);
        }
    }
    try {
        isLogined() && (await sessionCheckFunc().then((r) => r));
        const mallUserId = useUserStore.getState().mallUserId;
        const lists = await getOrderList(mallUserId, 10, (parseInt(params.offset) - 1) * 10, isIssue).then((r) => {
            if (r.status !== 200) throw r;
            const { orderList, totalCount } = r;
            return { orderList, totalCount };
        });
        const isNextLists = await getOrderList(mallUserId, 10, parseInt(params.offset) * 10, isIssue).then((r) => {
            if (r.status !== 200) throw r;
            const { orderList } = r;
            if (orderList.length === 0) return false;
            else return true;
            // return { orderList, totalCount }
        });
        const { orderList, totalCount } = lists;
        return { orderList, totalCount, isNextLists, isIssue };
    } catch (error) {
        console.log('error::::', error);
        if (error?.['status'] === 403 || error?.['statusCode'] === 403) throw { statusCode: 403 };
        else if (error?.['status'] === 401 || error?.['statusCode'] === 401) throw { statusCode: 401 };
        else return { orderList: [], totalCount: null, isNextLists: false, isIssue: '' };
    }
}

async function orderListLoaderV2({ params }, isIssue: boolean) {
    if (!isLogined()) {
        alert('로그인이 필요한 페이지입니다.');
        if (isIssue) {
            return redirect(`/mall/${params.path}/login?referer=/mall/${params.path}/refund-list/1`);
        } else {
            return redirect(`/mall/${params.path}/login?referer=/mall/${params.path}/order-n-shipping-info/1`);
        }
    }
    try {
        isLogined() && (await sessionCheckFunc().then((r) => r));
        const mallUserId = useUserStore.getState().mallUserId;
        const lists = await getOrderListV2(mallUserId, 10, (parseInt(params.offset) - 1) * 10, isIssue).then((r) => {
            if (r.status !== 200) throw r;
            const { items, totalCount } = r;
            return { items, totalCount };
        });
        const isNextLists = await getOrderListV2(mallUserId, 10, parseInt(params.offset) * 10, isIssue).then((r) => {
            if (r.status !== 200) throw r;
            const { items } = r;
            if (items.length === 0) return false;
            else return true;
        });
        const { items, totalCount } = lists;
        return { items, totalCount, isNextLists, isIssue };
    } catch (error) {
        console.log('error::::', error);
        if (error?.['status'] === 403 || error?.['statusCode'] === 403) throw { statusCode: 403 };
        else if (error?.['status'] === 401 || error?.['statusCode'] === 401) throw { statusCode: 401 };
        else return { items: [], totalCount: null, isNextLists: false, isIssue: '' };
    }
}

async function userCouponListLoader({ params }) {
    try {
        await sessionCheckFunc().then((r) => r);
        const { mallUserId } = useUserStore.getState();
        const couponList = await getUserCouponList(mallUserId);
        return { couponList: couponList.items };
    } catch (error) {
        return { couponList: [] };
    }
}

async function orderIssueListLoader({ params }) {
    // const mallUserId = useUserStore.getState().mallUserId;
    const { path } = params;
    if (!isLogined()) {
        alert('로그인이 필요한 페이지입니다.');
        return redirect(`/mall/${params.path}/login?referer=/mall/${params.path}/refund-list/1`);
    }
    try {
        isLogined() && (await sessionCheckFunc().then((r) => r));
        const mallUserId = useUserStore.getState().mallUserId;
        const lists = await getOrderList(mallUserId, 10, (parseInt(params.offset) - 1) * 10, 'yes').then((r) => {
            if (r.status !== 200) throw r;
            const { orderList, totalCount } = r;
            return { orderList, totalCount };
        });
        const isNextLists = await getOrderList(mallUserId, 10, parseInt(params.offset) * 10, 'yes').then((r) => {
            if (r.status !== 200) throw r;
            const { orderList } = r;
            if (orderList.length === 0) return false;
            else return true;
        });
        const { orderList, totalCount } = lists;
        // console.log("totalcount::::", totalCount)
        return { orderList, totalCount, isNextLists };
    } catch (error) {
        console.log(error);
        if (error?.['status'] === 403 || error?.['statusCode'] === 403) throw { statusCode: 403 };
        else if (error?.['status'] === 401 || error?.['statusCode'] === 401) throw { statusCode: 401 };
        else return { orderList: [], totalCount: null, isNextLists: false };
    }
}

async function myInquiryListLoader({ params }) {
    const { path } = params;
    if (!isLogined()) {
        alert('로그인이 필요한 페이지입니다.');
        return redirect(`/mall/${params.path}/login?referer=/mall/${params.path}/inquiry`);
    }
    // const mallUserId = useUserStore.getState().mallUserId;
    try {
        await sessionCheckFunc().then((r) => r);
        const mallUserId = useUserStore.getState().mallUserId;
        const { mallId } = await getMallId(path);
        const { inquiryList } = await getInquiryList(mallId, mallUserId)
            .then((r) => {
                if (r.status !== 200) throw { title: 'inquiryList' };
                else return r;
            })
            .catch((err) => {
                throw { title: 'inquiryList' };
            });
        const { items: groupPurchaseList, totalCount } = await getGroupPurchaseOrderList(mallUserId, mallId, 0)
            .then((r) => {
                // console.log(r)
                if (r.status !== 200) throw { title: 'orderList' };
                return r;
            })
            .catch((err) => {
                throw { title: 'orderList' };
            });
        return { lists: inquiryList, groupPurchaseList: groupPurchaseList, totalCount };
    } catch (error) {
        console.log(error);
        if (error?.['status'] === 403 || error?.['status'] === 401) throw error;
        else return { lists: [], groupPurchaseList: [] };
    }
}

async function noticeListLoader({ params }) {
    const { path } = params;
    try {
        await sessionCheckFunc().then((r) => r);
        const { mallId } = await getMallId(path);
        const lists = await getPinedNotification(mallId).then((r) => {
            if (r.status !== 200) throw r;
            else return r.notificationList;
        });
        return { lists };
    } catch (error) {
        return [];
    }
}

async function orderDetailInfoLoader({ params, request }) {
    const { orderGroupId = '', path = '' } = params;
    const requestUrl = '?' + String(request.url || '').split('?')[1];
    const queryString = new URLSearchParams(requestUrl);
    const orderNumber = String(queryString.get('orderNumber') || '');
    try {
        await sessionCheckFunc().then((r) => r);
        if (isLogined()) {
            if (!!orderNumber) {
                return { orderDetail: 'null', isIsland: false, noData: true };
            }
        } else {
            if (!!orderNumber) {
                const { accessToken, expiresIn } = await getNotLoginOrderV2(orderNumber).then((r) => {
                    if (r.status !== 200) throw r;
                    else return r;
                });
                useAnonymousUserStore.setState({
                    expiresIn,
                    accessToken: accessToken,
                });
                useOrderNumberStore.setState({
                    orderNumber: orderNumber,
                });
                axiosApi.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
                const { mallUserId } = await getMallUserIdByToken(accessToken);
                useAnonymousUserStore.setState({
                    mallUserId,
                });
            } else {
                alert('주문조회 권한이 없습니다.');
            }
        }
        const mallUserId = useUserStore.getState().mallUserId;
        const { mallId } = await getMallId(path);
        const { mallUserId: anonymousId } = useAnonymousUserStore.getState();
        const detailInfo = await getOrderDetailInfoV2(isLogined() ? mallUserId : anonymousId, orderGroupId).then(
            (r) => {
                if (r.status !== 200) throw r;
                return r.item;
            },
        );
        const couponList = await getOrderCouponList(isLogined() ? mallUserId : anonymousId, mallId, orderGroupId)
            .then((r) => r)
            .catch(() => []);
        const isIsland = await isIslandMountain(detailInfo.shippingAddressInfo.recipientPostCode);
        const isJeju = await isJejuShippingCost(detailInfo.shippingAddressInfo.recipientPostCode);
        return { orderDetail: detailInfo, isIsland, isJeju, couponList };
    } catch (error) {
        console.log(error);
        if (error?.['statusCode'] === 500 || error?.['status'] === 500) {
            throw error;
        } else if (error?.['statusCode'] === 422 || error?.['status'] === 422) {
            return { orderDetail: 'null', isIsland: false, noData: true };
        } else return { orderDetail: 'null', isIsland: false, couponResult: [] };
    }
}

/* 👇type */
export interface MallMainLoader {
    mallInfo: MallInfo['mallInfo'];
    tagNames: string[];
    notificationList: MallNotification['notificationList'];
    mallBusinessInfo: MallBusinessInfoType['mallBusinessInfo'];
    shopName: string;
}
export interface ProductDetailsLoader {
    productDetails: ProductDetailsType;
    drawerProductList: PurchaseDrawerStoreState['drawerProductList'];
    mallInfo: MallInfo['mallInfo'];
    mallBusinessInfo: MallBusinessInfoType['mallBusinessInfo'];
    shopName: string;
}
export interface OrderNPayLoaderReturnType {
    shippingAddressBookList: ShippingAddressBookType[];
    mileageList: Mileage['mileageList'];
    userInfo: MallUserInfoType;
    mallId: string;
    orderInfo: CreateOrderSheetReturnType['orderInfo'];
    couponList: UserCouponListType['items'];
    // salesPolicyInfo: SalesPolicyType,
    state: 'success' | 'fail';
    pgType: string;
    pgBusinessType: string;
    shoppingPoint: number;
    userPoint: number;
    shoppingPointPolicy: {
        id: string;
        policyName: string;
        targetUserType: string;
        pointConversionRate: number;
        maxUsageRate: number;
        minConversionAmount: number;
        minUsageAmount: number;
        isActive: boolean;
        priority: number;
        startDateTime: string;
        endDateTime: string;
    };
}
export interface FooterInfoDataType {
    mallBusinessInfo: MallBusinessInfoType['mallBusinessInfo'];
    shopName: string;
    mallId: string;
    mallInfo: MallInfo['mallInfo'];
}
export interface DestinationListLoaderReturnType {
    shippingAddressBookList: ShippingAddressBookType[];
}
export interface DestinationAdditionLoaderReturnType {
    userInfo: MallUserInfoType;
}
export interface MypageLoaderReturnType {
    userInfo: MallUserInfoType;
    mileage: number;
    mallId: string;
    state: 'success' | 'fail';
}
export interface PersonalnfoLoaderReturnType {
    userInfo: MallUserInfoType;
    shippingList: ShippingAddressBookType[];
}
export interface OrderNShippingInfoReturnType {}
export interface AdditionalPayReturnType {
    extraChargeInfo: ExtraChagreType['extraChargeInfo'];
}
export interface AdditionalPayResultReturnType {
    payResult: AdditionalPayResultType['extraChargeInfo'];
    paramData: {
        accountNumber: string;
        bank: string;
        customerName: string;
        dueDate: string;
        failMessage: string;
    };
}
export interface PayResultReturnType {
    orderDetailInfo: OrderDetailV2['item'];
    paramData: {
        accountNumber: string;
        bank: string;
        customerName: string;
        dueDate: string;
        failMessage: string;
        depositor: string;
    };
    couponList: OnlineCouponListType[];
    pgType: 'TOSS' | 'NICE';
}

/**
 * @description
 * `비회원일 경우 api_key를 이용해 토큰과 ID를 useAnonymousUserStore에 저장합니다.`
 */
export async function fetchNStoreAnonymousTokenNId() {
    const { reset: userReset } = useUserStore.getState();
    /* 비회원일 경우 토큰 발급 */
    const isAnonymousToken = useAnonymousUserStore.getState().accessToken ? true : false;
    // if (!isLogined() && !isAnonymousToken) {
    userReset();
    const { access_token } = await getTokenByAnonymous();
    axiosApi.defaults.headers.common.Authorization = `Bearer ${access_token}`;
    const { mallUserId } = await createAccountByToken(access_token);
    useAnonymousUserStore.setState({
        mallUserId,
        accessToken: access_token,
    });
}

async function sessionCheckFunc(notRefer = true) {
    // if (isLogined()) return;
    try {
        const isToken = await checkRefreshTokenBool().then((r) => r.data);
        if (isToken) {
            const { reset: anonymousUserReset } = useAnonymousUserStore.getState();
            anonymousUserReset();
            try {
                const { access_token, expires_in } = await checkRefreshToken()
                    .then((r) => r)
                    .catch((err) => {
                        throw err;
                    });
                useUserStore.setState({
                    accessToken: access_token,
                    expiresIn: expires_in,
                });
                axiosApi.defaults.headers.common.Authorization = `Bearer ${access_token}`;
                const isMallUser = await checkIsMallUser(access_token).then((r) => r.data);
                if (isMallUser) {
                    const { mallUserId } = await getMallUserIdByToken(access_token).then((r) => r);
                    useUserStore.setState({ mallUserId });
                } else {
                    const { mallUserId } = await createAccountByToken(access_token).then((r) => r);
                    useUserStore.setState({ mallUserId });
                }
            } catch (err) {
                router.navigate(`/logout`);
                throw err;
            }
        } else {
            await fetchNStoreAnonymousTokenNId();
        }
        if (!notRefer) return;
        const queryString = new URLSearchParams(window.location.search);

        // 출처 - 후킹스프 기여도
        const utm_source = queryString.get('utm_source') || '';
        // 매체 - 쇼츠 피드를 보고 넘어옴
        const utm_medium = queryString.get('utm_medium') || '';
        // 인스타셀러 아이디 or 플로잉 닉네임 - 누가 등록한 영상을 보고 넘어왔는가
        // (크롤링 쇼츠의 경우 sns 아이디, 직접 등록한 경우 플로잉 닉네임)
        const utm_campaign = queryString.get('utm_campaign') || '';
        // 상품 아이디 - 해당 상품 구매에만 referrerToken 사용 가능
        const utm_campaign_id = queryString.get('utm_campaign_id') || '';
        const utm_referrer = queryString.get('utm_referrer') || '';
        const utm_content = queryString.get('utm_content') || '';
        const utm_term = queryString.get('utm_term') || '';

        const referer = queryString.get('referer') || '';
        const user_id = queryString.get('user_id') || '';

        const isValidQuery =
            utm_source ||
            utm_medium ||
            utm_campaign ||
            utm_referrer ||
            referer ||
            utm_campaign_id ||
            user_id ||
            utm_content ||
            utm_term;

        const queryPayload = {
            utm_source,
            utm_medium,
            utm_campaign,
            utm_referrer,
            utm_campaign_id,
            user_id,
            referer,
            utm_content,
            utm_term,
        };

        if (isValidQuery) {
            const token: string =
                (await setReferrerToken({ ...queryPayload })
                    .then((r) => r)
                    .catch(() => '')) || '';
            useSourcingReferrerStore.setState({
                referrer_token: token,
            });
        } else {
            const token: string =
                (await setReferrerRefreshToken({ ...queryPayload })
                    .then((r) => r)
                    .catch(() => '')) || '';
            useSourcingReferrerStore.setState({
                referrer_token: token,
            });
        }
    } catch (error) {
        const err: any = error;
        console.log(err);
        if (!err.status || !err.statusCode) {
            throw { status: -1 };
        }
        try {
            router.navigate(`/logout`);
        } finally {
        }
    }
}
export interface OrderListLoaderType {
    orderList: UserOrder[];
    totalCount: number | null;
    isNextLists: boolean;
    isIssue: 'yes' | '';
}
export interface OrderListLoaderV2Type {
    items: UserOrderV2[];
    totalCount: number | null;
    isNextLists: boolean;
    isIssue: boolean;
}

export interface MyInquiryListLoaderType {
    lists: Inquiries['inquiryList'];
    groupPurchaseList: GroupPurchaseOrderType[];
    totalCount: number;
}

export interface NoticePageLoaderType {
    lists: MallNotification['notificationList'];
}

export interface OrderDetailInfoLoaderType {
    orderDetail: OrderDetail['orderDetailInfo'] | 'null';
    isIsland: boolean;
    isJeju: boolean;
    noData?: boolean;
    couponList: OnlineCouponListType[];
}

export interface OrderDetailInfoLoaderTypeV2 {
    orderDetail: OrderDetailV2['item'] | 'null';
    isIsland: boolean;
    isJeju: boolean;
    noData?: boolean;
    couponList: OnlineCouponListType[];
}

interface Designdata {
    spacehome_create_step: number;
    design_type: string;
    bg_filter_type: string;
    bg_type: string;
    description: string;
    sub_description: null;
    bg_color: string;
    text_color: string;
    button_color: string;
    profile_img_url: string;
    banner_img_url: string;
    bg_img_url: string;
    is_button_animated: boolean;
    is_theme: boolean;
    path: string;
}
export interface SpaceHomeV2LoaderReturnType {
    design_data: Designdata;
    item_list: any;
    user_id: string;
    is_mall_opened: boolean;
    nickname: string;
}

function ErrorComponent() {
    const error: any = useRouteError();
    console.log('error::::', error);
    return <NotFound error={error} />;
}

export default router;
